import React, { FC } from 'react'
import styles from '../../threePsStyles.module.css'
import { pluralize } from '../../threePsTable.utils'

interface AccordianHeaderProps {
    label: string
    primaryColor: string
    entriesLength: number
}

export const AccordianHeader: FC<AccordianHeaderProps> = ({ label, primaryColor, entriesLength }) => {
    return (
        <div className={styles.accordionHeaderItem}>
            <p className={styles.accordionHeaderItemText} style={{ color: primaryColor }}>
                {label}
            </p>
            <p className={styles.accordionHeaderItemValue}>
                {pluralize(entriesLength, 'code')}
            </p>
        </div>
    )
}
